export default __webpack_public_path__ + "e0d70c5177d1cfe075e2de07908890c9.svg";